import { AddressDetails } from './address-details';
import { NomineeDetails } from './nominee-details';
import { SegmentDetails } from './segment-details';
import { BankDetails } from './bank-details';
import { DocumentDetails } from './document-details';
import { InvestorAccount } from './investor-account';
import { InvestorDetails } from './investor-details';

/** investor detail */
export class Investor {
    /** id */
    id: string;
    /** lid */
    lid: string;
    /** entityId */
    entityId: string;
    /** leadStatusMasterDto */
    leadStatusMasterDto: ILeadStatus;
    /** businessUnitMasterDto */
    businessUnitMasterDto: IBusinessUnit;
    /** pannum */
    pannum: string;
    /** aadhaarNum */
    aadhaarNum: string;
    /** isKYC */
    isKYC: string;
    /** deletedBy */
    deletedBy: string;
    /** deletedOn */
    deletedOn: number;
    /** deviceID */
    deviceID: string;
    /** password */
    password: string;
    /** isReviewed */
    isReviewed: string;
    /** expiryAccountOtp */
    expiryAccountOtp: string;
    /** recoverAccountOtp */
    recoverAccountOtp: string;
    /** isPorting */
    isPorting: string;
    /** directPlan */
    directPlan: string;
    /** isNomineeSkipped */
    isNomineeSkipped: string;
    /** kycMode */
    kycMode: any;
    /** addressDtoList */
    addressDtoList: Array<AddressDetails>;
    /** nomineeDetailsDtoList */
    nomineeDetailsDtoList: Array<NomineeDetails>;
    /** investorSegmentDtoList */
    investorSegmentDtoList: Array<SegmentDetails>;
    /** investorBankDetailsDtoList */
    investorBankDetailsDtoList: Array<BankDetails>;
    /** documentsIPVDtoList */
    documentsIPVDtoList: Array<IDocIPV>;
    /** eSignTransactionLogDtoList */
    eSignTransactionLogDtoList: Array<any>;
    /** investorDetailsDtoList */
    investorDetailsDtoList: Array<InvestorDetails>;
    /** documentsDtoList */
    documentsDtoList: Array<DocumentDetails>;
    /** onBoardingTrackerDtoList */
    onBoardingTrackerDtoList: Array<any>;
    /** investorAccountDetailsDtoList */
    investorAccountDetailsDtoList: Array<InvestorAccount>;
    /** reportInvestorActionsDtoList */
    reportInvestorActionsDtoList: Array<any>;
    /** optSegments */
    optSegments: string;
    /** loginAuthResDto */
    loginAuthResDto: ILoginAuth;
    /** userValidationStatus */
    userValidationStatus: any;
    /** tag */
    tag: any; 

/** Initializes the component with default values. */
    constructor() {
        this.isKYC = 'N';
        this.isPorting = 'N';
        this.addressDtoList = [];
        this.nomineeDetailsDtoList = [];
        this.investorSegmentDtoList = [];
        this.investorBankDetailsDtoList = [];
        this.documentsIPVDtoList = [];
        this.investorDetailsDtoList = [new InvestorDetails()];
        this.documentsDtoList = [];
        this.investorAccountDetailsDtoList = [new InvestorAccount()];
        this.reportInvestorActionsDtoList = [];
        this.loginAuthResDto = null;
        this.isNomineeSkipped = 'Y';
        this.isReviewed = 'N';
        this.tag = null;
    }
}
/** LeadStatus */
export interface ILeadStatus {
    /** id */
    id: string;
    /** leadStatusName */
    leadStatusName: string;
}
/** BusinessUnit */
export interface IBusinessUnit {
/**     id */
    id: string;
/**     name */
    name: string;
    /** smsSenderKey */
    smsSenderKey?: string
}

/** Doc IPV  */
export interface IDocIPV {
/**     id  */
    id?: string;
    /** investorIdid  */
    investorId?: string;
    /** ipvImageFileNameid  */
    ipvImageFileName?: string;
    /** ipvVideoFileNameid  */
    ipvVideoFileName?: string;
    /** ipvPersonIdid  */
    ipvPersonId?: string;
    /** ipvOtpid  */
    ipvOtp?: string;
    /** ipvFileNameApproveStatusid  */
    ipvFileNameApproveStatus?: string;
    /** lastModifiedDateid  */
    lastModifiedDate?:string;
    /** createdDateid  */
    createdDate?: string;
    /** ipvVerifiedByid  */
    ipvVerifiedBy?:any;
}
/** Login Auth  */
export interface ILoginAuth {
    /** issued */
    issued: string;
    /** access_token */
    access_token: string;
    /** directExpiry */
    directExpiry: string;
    /** directFlag */
    directFlag: string;
    /** displayCode */
    displayCode: string;
    /** error */
    error: string;
    /** expires_in */
    expires_in: string;
    /** isFirstTimeLogin */
    isFirstTimeLogin: string;
    /** onboardFlag */
    onboardFlag: string;
    /** refresh_token */
    refresh_token: string;
    /** token_type */
    token_type: string;
    /** userName */
    userName: string;
    /** desc */
    desc: string;
}



